import { Engine } from './core/Engine';
import { DebugUI } from './ui/DebugUI';

// Main initialization function
const init = async () => {
  // Get engine instance
  const engine = Engine.getInstance();
  
  // Expose engine to window for debugging
  (window as any).engine = engine;
  
  // Expose the scene and object factory for easier debugging
  (window as any).scene = engine.getScene();
  (window as any).objectFactory = engine.getScene().getObjectFactory();
  
  // Create debug UI
  const debugUI = new DebugUI(
    engine.getTime(), 
    engine.getCamera(),
    engine.getScene()
  );
  
  // Start the engine
  engine.start();
  
  // Update loop for UI
  const updateUI = () => {
    debugUI.update();
    requestAnimationFrame(updateUI);
  };
  updateUI();
  
  console.log('Game initialized and started');
  console.log('Toasters are now pathfinding to the giant bread loaf!');
  console.log('Blender towers are now defending against the toasters!');
};

// Start the application
init().catch(console.error); 